export const migrations = {
  0: (state) => {
    return {}
  },
  1: (state) => {
    return {}
  },
};



// WEBPACK FOOTER //
// ./src/store/migrations.js